<div>
    <p-panel
             header="{{ 'cs.bia.analysis.generatedSQL' | hisUi }}"
             [toggleable]="true"
             [collapsed]="true">
        <div
             class="infoMessage"
             [innerHTML]="'cs.bia.analysis.sql.info' | hisUi">
        </div>
        <div class="clearAndSpace"></div>
        @if(noAggregatesSQL){
        <p-panel header="{{ 'cs.bia.analysis.flatTable' | hisUi }}"
                 [style]="{ overflowX: 'auto', }">
            <his-display-code [showLineNumbers]="true">
                <pre><code class="language-sql" pCode >{{ noAggregatesSQL }}</code></pre>
            </his-display-code>
        </p-panel>
        }
        <div class="clearAndSpace"></div>
        <!-- Bei Berichten ohne hierarchischen Header wird keine Gesamtspalte mitgeschickt / ausgewertet -->
        @if(totalsColumnSQL){
        <p-panel header="{{ 'cs.bia.analysis.column.total' | hisUi }}">
            <his-display-code [showLineNumbers]="true">
                <pre><code class="language-sql" pCode >{{ totalsColumnSQL }}</code></pre>
            </his-display-code>
        </p-panel>
        }
    </p-panel>
</div>